<template>
  <div :class="{ container: !isMobile, 'pb-70': isMobile }">
    <breadcrumb v-if="!isMobile" crumb="auto-add" />
    <div v-else style="padding-bottom: 20px">
      <el-button style="width: 100% !important" @click="goToList">
        Вернуться к списку
      </el-button>
    </div>
    <el-row :gutter="isMobile ? 0 : 24">
      <el-col :span="!isMobile ? 18 : 24">
        <el-form ref="formAddAuto" :model="dataForSave" @submit.native.prevent>
          <div class="my_container-card">
            <el-card class="box-card">
              <div v-if="!isMobile" slot="header" class="clearfix">
                <span>
                  <b>Добавление автомобиля</b>
                </span>
              </div>
              <section :class="{ my_container: !isMobile }">
                <add-new-auto
                  @clear="clearForm"
                  @saved="setAutoId"
                  @editAuto="editAuto"
                  @helper="helpMe"
                />
                <set-reason
                  v-if="car.id !== 0 && canAction('action_set_reason')"
                  :reason="reason"
                  @changed="setReason"
                />
                <el-row v-if="car.id">
                  <el-col :xs="24" :sm="12">
                    <el-form-item prop="vehicle_type_id">
                      <p>Выбор типа авто:</p>
                      <el-select
                        v-model="dataForSave.vehicle_type_id"
                        placeholder="Выберите"
                      >
                        <el-option
                          v-for="item in autoTypes"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <form-reason
                  v-if="reason"
                  ref="filesEntityContainer"
                  :car="car"
                  @changed="updateAuto"
                  @saved="saveAuto"
                />
              </section>
            </el-card>
          </div>
        </el-form>
      </el-col>
      <el-col v-if="!isMobile" :span="6">
        <hint :text="helper" />
      </el-col>
    </el-row>
    <auto-edit :edit-auto="idEditAuto" @updated="updateAuto" />
  </div>
</template>

<script>
import { DEFAULT_VIN_VALUE } from '@/datas/consts'
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import AddNewAuto from './AddForms/AddNewAuto'
import Auto from '@/datas/Autos'
import AutoEdit from './Auto-edit'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import FormReason from './AddForms/FormReason'
import Hint from '@/components/Hints/Hint'
import SetReason from './AddForms/SetReason'

const AutoRepository = RepositoryFactory.get('auto')

export default {
  name: 'AddForm',
  components: {
    Hint,
    AddNewAuto,
    SetReason,
    FormReason,
    AutoEdit,
    Breadcrumb,
  },
  data() {
    return {
      car: { id: 0 },
      reason: 0,
      dataForSave: {
        user_org_inn: '',
        sts: '',
        sts_date: '',
        mark: '',
        plateTrailer: '',
        stsTrailer: '',
        vehicle_type_id: 1,
      },
      idEditAuto: {},
      autoSaved: false,
      helper: this.defaultHelper,
      defaultHelper:
        'Данный раздел предназначен для добавления автомобилей в аккредитацию',
    }
  },
  computed: {
    ...mapGetters({ autoTypes: 'autos/getAutoTypes' }),
  },
  mounted() {
    this.setOwnerParams()
    this.fetchAutoTypes()
  },
  methods: {
    ...mapActions({ fetchAutoTypes: 'autos/fetchAutoTypes' }),
    setOwnerParams() {
      const { inn, short_name } = this.userInfo.current.organization

      this.dataForSave.innCarrier = inn
      this.dataForSave.user_org_inn = inn
      this.dataForSave.innOwner = inn
      this.dataForSave.nameCarrier = short_name
      this.dataForSave.nameOwner = short_name
    },
    goToList() {
      const path =
        this.$route.name === 'AutoAddMobile' ? '/autos-mobile' : '/auto/list'

      this.$router.push({ path })
    },
    helpMe(text) {
      this.helper = text || this.defaultHelper
    },
    editAuto(idAuto) {
      this.idEditAuto = idAuto
    },
    setReason(reason) {
      this.hideAllField()
      this.reason = reason
      this.car.isOwner = this.reason
    },
    hideAllField() {
      this.autoSaved = false
    },
    clearForm() {
      this.car = { id: 0 }
      this.reason = 0
      this.hideAllField()
    },
    updateAuto(data) {
      for (let key in data) {
        this.dataForSave[key] = data[key]
      }
    },
    countFilesValidate() {
      /** Берем ссылки добавления прицепа, проверяем count файлов */
      const { filesEntityContainer: refC } = this.$refs || {}

      return refC.filesIsValid()
    },
    setAutoId(plate) {
      if (!plate) {
        this.clearForm()

        return false
      }
      let data = {}

      if (this.isDriverRole) {
        const { innCarrier, innOwner, nameCarrier, nameOwner } =
          this.dataForSave

        data = { innCarrier, innOwner, nameCarrier, nameOwner }
      }
      data.user_org_inn = this.dataForSave.user_org_inn

      AutoRepository.addCar(plate, data)
        .then(res => {
          this.car = new Auto(res.data).onlyValue()

          if (this.isMobile || this.isDriverRole) {
            this.setReason(1)
          }
        })
        .catch(err => this.errHandler(err))
    },
    saveAuto(data) {
      if (!this.countFilesValidate()) {
        return false
      }
      this.updateAuto(data)
      this.$refs['formAddAuto'].validate(valid => {
        if (valid) {
          if (this.dataForSave.vin === DEFAULT_VIN_VALUE) {
            this.dataForSave.vin = ''
          }
          AutoRepository.updateAutoFromData(this.car.id, this.dataForSave)
            .then(() => {
              if (this.isDriverRole && !this.userInfo.has_autos) {
                this.$store.dispatch(`userProfile/${GET_PROFILE}`)
              }
              this.autoSaved = true

              if (data.plateTrailer !== undefined) {
                this.$alert('Авто добавлено успешно', 'Успешно', {
                  customClass: this.isMobile ? 'classAlertError' : '',
                })
                this.goToList()
              }
            })
            .catch(err => this.errHandler(err))
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="sass">
.my_container-card .el-card__body
  padding: 10px
.classAlertError
  width: 100% !important
.add-new_car
  .results
    span
      font-size: 13px
      line-height: 19px
      color: #B5B5B5
    p
      margin: 0
      font-size: 14px
      line-height: 17px
  .search-button
    font-weight: bold
    font-size: 14px
    line-height: 17px
    text-align: center
    text-transform: uppercase
    color: #778CA2
    background: #F2F4F6
    border-radius: 4px
    border: none
    height: 46px
    width: 150px
    &:hover
      cursor: pointer
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
      transition: all 0.2s
</style>
